import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useAccountDeletionEligibilityApi } from 'services/user/useAccountDeletionEligibilityApi';

export const useGetAccountDeletionEligibility = (
  userId: string | undefined,
  enabled = true
) => {
  const { getAccountDeletionEligibility } = useAccountDeletionEligibilityApi();

  return useQuery({
    queryKey: [queryKeys.getAccountDeletionEligibility, userId],
    queryFn: () => getAccountDeletionEligibility(userId ?? ''),
    enabled: Boolean(userId) && enabled
  });
};
